import userService from "../services/userService";
import userType from "../constants/userType";
import role from "@/constants/role";

const SELECTED_COMPANY_KEY = "dovcue.exchange.selectedCompanyId";

const parseCompanyId = value => {
  const id = parseInt(value);
  return Number.isInteger(id) ? id : null;
};

export default {
  namespaced: true,

  state: {
    auth0Initialized: false,
    user: { roles: [], companies: [] },
    selectedCompanyId: parseCompanyId(sessionStorage.getItem(SELECTED_COMPANY_KEY)),
  },

  getters: {
    user: state => {
      return { ...state.user };
    },
    userRoles: state => state.user.roles,
    companies: state =>
      [...state.user.companies].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)),
    isOnBoardingPending: state =>
      state.user.companies.find(c => c.id === state.selectedCompanyId)?.onBoardingProcessPending,
    isGlobalUser: state => state.user.userType.id === userType.Global,
    isAdmin: state => state.user.roles.includes(role.Administrator),
    selectedCompanyId: state => state.selectedCompanyId,
  },

  mutations: {
    mutateAuth0Initialized: (state, auth0Initialized) => (state.auth0Initialized = auth0Initialized),
    mutateUser: (state, user) => (state.user = { ...user, companies: state.user.companies }),
    mutateSelectedCompanyId: (state, selectedCompanyId) => (state.selectedCompanyId = selectedCompanyId),
    updateProfile: (state, profile) => (state.user = { ...state.user, ...profile }),
    mutateCompnies: (state, companies) => state.user.companies.push(...companies),
  },
  actions: {
    updateCompanyId({ commit }, { selectedCompanyId }) {
      const id = parseCompanyId(selectedCompanyId);
      if (id === null) return;
      commit("mutateSelectedCompanyId", id);
      sessionStorage.setItem(SELECTED_COMPANY_KEY, id);
    },

    updateUser({ commit }, { user }) {
      const existing = parseCompanyId(sessionStorage.getItem(SELECTED_COMPANY_KEY));

      let selectedCompanyId = user.companies[0].id;

      // Make sure its a valid company ID that the user has access to
      if (existing && user.companies.find(c => c.id === existing)) {
        selectedCompanyId = existing;
      }

      sessionStorage.setItem(SELECTED_COMPANY_KEY, selectedCompanyId);
      commit("mutateUser", user);
      commit("mutateSelectedCompanyId", selectedCompanyId);
    },

    updateAuth0Initialized({ commit }) {
      commit("mutateAuth0Initialized", true);
    },

    updateCompanies({ commit }, companies) {
      commit("mutateCompnies", companies);
    },

    clearSelectedCompanyId({ commit }) {
      sessionStorage.removeItem(SELECTED_COMPANY_KEY);
      commit("mutateSelectedCompanyId", null);
    },

    async saveUserProfile({ commit }, profile) {
      const { firstName, lastName, displayName, emailAddress, title } = await userService.updateUser(profile);
      commit("updateProfile", { firstName, lastName, displayName, emailAddress, title });
    },

  },
};
